import { forwardRef, InputHTMLAttributes } from 'react'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'



interface RadioProps extends InputHTMLAttributes<HTMLInputElement> {
  radioSize?: 'extra_small' | 'small' | 'medium' | 'large';
  label?: string;
}

const Radio = forwardRef<HTMLInputElement, RadioProps>((props, ref) => {
  const { radioSize = 'medium', label, ...rest } = props

  return (
    <label className={cn(styles.root, styles[radioSize])}>
      <input className={styles.input} type="radio" ref={ref} {...rest} />
      <span className={styles.icon}></span>
      {label && <span className={styles.label}>{label}</span>}
    </label>
  )
})

Radio.displayName = 'Radio'

export default Radio
